import React from "react";
import { Tooltip } from "antd";
import type { TooltipProps } from "antd";
import { createGlobalStyle } from "styled-components";

const APP_TOOLTIP_CLASS = "app-tooltip";

export const AppTooltipGlobalStyle = createGlobalStyle`
    .app-tooltip .ant-tooltip-inner {
        background-color: var(--app-tooltip-bg, #454545) !important;
        backdrop-filter: blur(var(--app-tooltip-blur, 4px));
        
        /* Optional: better text wrapping when tooltip is wide */
        white-space: pre-wrap;
        word-break: break-word;
    }
`;

type AppTooltipProps = TooltipProps & {
	backgroundColor?: string;
	blurPx?: number;
	maxWidth?: string | number; // ← Add this
};

type AppTooltipStyle = React.CSSProperties & {
	"--app-tooltip-bg": string;
	"--app-tooltip-blur": string;
};

export const AppTooltip: React.FC<AppTooltipProps> = ({
	backgroundColor = "#454545",
	blurPx = 4,
	maxWidth = 250, // default = antd default
	overlayClassName,
	overlayStyle,
	children,
	...rest
}) => {
	const mergedOverlayClassName = [APP_TOOLTIP_CLASS, overlayClassName].filter(Boolean).join(" ");

	const mergedOverlayStyle: AppTooltipStyle = {
		...overlayStyle,
		"--app-tooltip-bg": backgroundColor,
		"--app-tooltip-blur": `${blurPx}px`,
		maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth, // ← Key change
	};

	return (
		<Tooltip {...rest} overlayClassName={mergedOverlayClassName} overlayStyle={mergedOverlayStyle}>
			{children}
		</Tooltip>
	);
};
